import request from "../../utils/api";

export const whoami = params => {
  return request("v1/sellers/me", {
    params
  });
};
//folder
export const getKnowledgeCenterFolder = () => {
  return request(`v1/sellers/knowledge-center-folder`);
};

export const getIncentive = () => {
  return request(`v1/cms/incentive`);
};

export const getKnowledgeCenter = () => {
  return request(`v1/cms/knowledge-center`);
};

export const postKnowledgeCenterFavorite = params => {
  const { id } = params;

  return request(`v1/cms/knowledge-center/favorite/${id}`, {
    method: "put",
    body: params
  });
};

export const postIncentiveFavorite = params => {
  const { id } = params;

  return request(`v1/cms/incentive/favorite/${id}`, {
    method: "put",
    body: params
  });
};
